
export const ITEM_OPTIONS = [{
    id: 'sku_memory',
    name: '内存',
    multipleChoice:1
  },
  {
    id: 'sku_purchase_channel',
    name: '购买渠道',
    multipleChoice:1
  },
  {
    id: 'sku_body_color',
    name: '机身颜色',
    multipleChoice:1
  },
  {
    id: 'sku_warranty_duration',
    name: '保修时长',
    multipleChoice:1
  },
  {
    id: 'sku_small_model',
    name: '小型号',
    multipleChoice:1
  },
  {
    id: 'sku_network',
    name: '网络制式',
    multipleChoice:1
  },
  {
    id: 'sku_cpu',
    name: '处理器',
    multipleChoice:1
  },
  {
    id: 'sku_graphics_card',
    name: '显卡',
    multipleChoice:1
  },
  {
    id: 'sku_solid_drive',
    name: '固态硬盘',
    multipleChoice:1
  },
  {
    id: 'sku_mechanical_drive',
    name: '机械硬盘',
    multipleChoice:1
  },
  {
    id: 'sku_charging_interface',
    name: '充电接口',
    multipleChoice:1
  },
  {
    id: 'sku_charging_method',
    name: '充电方式',
    multipleChoice:1
  },
  {
    id: 'sku_case_size',
    name: '表壳尺寸',
    multipleChoice:1
  },
  {
    id: 'sku_case_material',
    name: '表壳材质',
    multipleChoice:1
  },
  {
    id: 'sku_watch_strap',
    name: '表带',
    multipleChoice:1
  },
  {
    id: 'sku_strap_color',
    name: '表带颜色',
    multipleChoice:1
  },
  {
    id: 'sku_left_right_ear',
    name: '左右耳',
    multipleChoice:1
  },
  {
    id: 'sku_external_keyboard',
    name: '外置键盘',
    multipleChoice:1
  },
  {
    id: 'sku_accessories_situation',
    name: '配件情况',
    multipleChoice:1
  }
]